import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import styles from "./DynamicReportModal.module.css";
import { HiDownload } from "react-icons/hi";

import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import RadioComponent from "../../components/RadioComponent/RadioComponent";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";

const DynamicReportModal = () => {
  const dispatch = useDispatch();
  const { config = {} } = useSelector((state) => state.modal);

  const {
    title = "Report",
    lastGenerated = null,
    fields = [],
    showAutoFill = false,
  } = config;

  const [selectedRadios, setSelectedRadios] = useState({});

  const handleClose = () => dispatch(closeModal());
  const [autoFill, setAutoFill] = useState(false);


  const handleGenerate = () => {
    console.log("Generate Report:", title);
    dispatch(closeModal());
  };

  return (
    <div className={styles.modalWrapper}>
      <div className={styles.header}>
        <span>{title}</span>
        <ToClose onClose={handleClose} />
      </div>

      <div className={styles.bodycontent}>
        <div className={styles.body}>
          {lastGenerated && (
            <div className={styles.generated}>
              <span>Last Generated on {lastGenerated}</span>
              <HiDownload
                className={styles.downloadIcon}
                onClick={() => console.log("Download icon clicked")}
              />
            </div>
          )}

          {fields.map((field, idx) => {
            if (field.type === "dateRange") {
              return (
                <div key={idx} className={styles.inputGroup}>
                  <div className={styles.label}>{field.label}</div>
                  <div className={styles.rangeInputs}>
                    <input type="date" />
                    <span>to</span>
                    <input type="date" />
                  </div>
                </div>
              );
            }

            if (field.type === "radio") {
              return (
                <div key={idx} className={styles.inputGroup}>
                  {field.label && <label>{field.label}</label>}
                  <div className={styles.radioGroup}>
                    {field.options.map((opt) => (
                      <RadioComponent
                        key={opt.value}
                        name={field.name}
                        value={opt.value}
                        label={opt.label}
                        checked={selectedRadios[field.name] === opt.value}
                        onChange={() =>
                          setSelectedRadios((prev) => ({
                            ...prev,
                            [field.name]: opt.value,
                          }))
                        }
                      />
                    ))}
                  </div>
                </div>
              );
            }

            if (field.type === "dropdown") {
              return (
                <div className={styles.dropdown}>
                  <HeadingAndDropDown
                    key={idx}
                    label={field.label}
                    name={field.name}
                    value={field.value || ""}
                    onChange={() => {}} // plug in handlers if needed
                    options={field.options || []}
                    placeholder={field.placeholder || ""}
                  />
                </div>
              );
            }

            if (field.type === "date") {
              return (
                <div key={idx} className={styles.inputGroup}>
                  <label>{field.label}</label>
                  <input type="date" />
                </div>
              );
            }

            return null;
          })}

          {showAutoFill && (
            <div className={styles.autoFillRow}>
              <input
                type="checkbox"
                id="autoFill"
                checked={autoFill}
                onChange={(e) => setAutoFill(e.target.checked)}
              />
              <label htmlFor="autoFill">Auto Fill Report Data</label>
            </div>
          )}
        </div>

        <div className={styles.footer}>
          <SaveAndCancel
            onCancel={handleClose}
            onSave={handleGenerate}
            saveLabel="Generate Report"
          />
        </div>
      </div>
    </div>
  );
};

export default DynamicReportModal;
